<mat-sidenav-container>
    <mat-sidenav #sidenav [(opened)]="opened">
        <mat-nav-list>
            <mat-accordion>
                <lib-sidenav-item icon="home" routerLink="/" (click)="toggle()">
                    {{language.Home | translationPipe}}
                </lib-sidenav-item>
                <lib-sidenav-item icon="calendar_month" routerLink="/calendar" (click)="toggle()">
                    {{language.calendar | translationPipe}}
                </lib-sidenav-item>
                @if(permissionService.DebitorLesen){
                <lib-sidenav-item icon="person" routerLink="/debitor" (click)="toggle()">
                    {{language.debitoren |translationPipe}}
                </lib-sidenav-item>
                }
                @if(permissionService.StandortLesen){
                <lib-sidenav-item icon="Store" routerLink="/standort" (click)="toggle()">
                    {{language.Standort |translationPipe}}
                </lib-sidenav-item>
                }                
                @if(permissionService.ObjektLesen){
                <lib-sidenav-item icon="apartment" routerLink="/objekt" (click)="toggle()">
                    {{language.objekt |translationPipe}}
                </lib-sidenav-item>
                }
                @if(permissionService.RoofareaLesen){
                <lib-sidenav-item icon="roofing" routerLink="/roofarea" (click)="toggle()">
                    {{language.roofarea |translationPipe}}
                </lib-sidenav-item>
                }
                @if(permissionService.SicherungssystemLesen){
                <lib-sidenav-item icon="lan" routerLink="sicherungssystem" (click)="toggle()">
                    {{language.Sicherungssystem |translationPipe}}
                </lib-sidenav-item>
                }                
                @if(permissionService.SafetyPointLesen){
                <lib-sidenav-item icon="safety_check" routerLink="/safetypoint" (click)="toggle()">
                    {{language.safetypoint | translationPipe}}
                </lib-sidenav-item>
                }
                @if(permissionService.serviceLesen){
                <lib-sidenav-item icon="contract" routerLink="/service" (click)="sidenav.toggle()">
                    {{language.service | translationPipe}}
                </lib-sidenav-item>
                }

                @if(appService.isUserAdmin()){
                <mat-divider></mat-divider>
                <lib-sidenav-item icon="settings" routerLink="/verwaltung" (click)="sidenav.toggle()">
                    {{language.Verwaltung | translationPipe}}
                </lib-sidenav-item>
                }
            </mat-accordion>
        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>